export const CARD_BRANDS = [
    "visa",
    "mastercard",
    "jcb",
    "amex",
    "diners",
    "unionpay",
    "discover",
];
//# sourceMappingURL=account.js.map